"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../../Log/LogManager");
const IFudaoFactory_1 = require("../IFudaoFactory");
const FudaoDefinition_1 = require("../FudaoDefinition");
const Fudao_1 = require("../Fudao");
const FudaoUser_1 = require("../FudaoUser");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const FudaoCommand_1 = require("../FudaoCommand");
const RtcCommand_1 = require("../../Engine/Command/RtcCommand");
class FudaoClientFactory {
    constructor(ccas, fptc, ifsf, fudaoRepo, cmdHub, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoClientFactory");
        this._chatAppService = ccas;
        this._fudaoPassedTimeCounter = fptc;
        this._sessionFacade = ifsf;
        this._fudaoRepo = fudaoRepo;
        this._commandHub = cmdHub;
        this._eventHub = evtHub;
    }
    async NewFudaoAsync(t, s) {
        if (!t.IsTeacher)
            throw new IFudaoFactory_1.FudaoFactoryError(`${t.Name} should be teacher.`);
        if (!s.IsStudent)
            throw new IFudaoFactory_1.FudaoFactoryError(`${s.Name} should be student.`);
        // 取輔導所在的Chat.Id
        const chatId = await this._chatAppService.openOrCreateChatWithAsync([s.Name]);
        if (TypeScriptUtils_1.isNullOrEmpty(chatId))
            throw new IFudaoFactory_1.FudaoFactoryError("Can't open chat.");
        // 用CmdHub發http取Fudao的Id
        const createFudaoCmd = FudaoCommand_1.FudaoCommand.TeacherCreatedFudaoCommand({
            "teacherId": t.Id,
            "studentId": s.Id,
            "chatId": chatId
        });
        const cmdResult = await this._commandHub.sendCommandAsync(createFudaoCmd);
        if (cmdResult.type !== RtcCommand_1.CmdType.ResponseAccept)
            throw new IFudaoFactory_1.FudaoFactoryError(`Failed to create fudao. reason=${cmdResult.message}`);
        const cmdResultJson = cmdResult.contentTo();
        const fudaoId = cmdResultJson["_id"];
        const fudaoStandardDuration = cmdResultJson["standardDuration"] || 0;
        const fudaoExtendDuration = cmdResultJson["extendDuration"] || 0;
        this._logger.debug("New {nameof(Fudao.Id)} is {fudaoId}");
        if (!fudaoId)
            throw new Fudao_1.FudaoError("Fudao.Id should not be empty.");
        return new Fudao_1.Fudao(false, this._commandHub, this._eventHub, this._fudaoRepo, this._fudaoPassedTimeCounter, this._sessionFacade, {
            id: fudaoId,
            Teacher: t,
            Student: s,
            StandardDuration: fudaoStandardDuration,
            ExtendDuration: fudaoExtendDuration,
            ChatId: chatId,
        });
    }
    CreateFudaoFrom(fudaoDto) {
        return new Fudao_1.Fudao(false, this._commandHub, this._eventHub, this._fudaoRepo, this._fudaoPassedTimeCounter, this._sessionFacade, {
            id: fudaoDto.id,
            Teacher: new FudaoUser_1.FudaoUser(fudaoDto.teacher),
            Student: new FudaoUser_1.FudaoUser(fudaoDto.student),
            StandardDuration: fudaoDto.standardDuration,
            ExtendDuration: fudaoDto.extendDuration,
            StartTime: new Date(fudaoDto.startTime),
            EndTime: new Date(fudaoDto.endTime),
            Status: fudaoDto.status,
            ChatId: fudaoDto.chatId,
            DataSession: new FudaoDefinition_1.FudaoSession(fudaoDto.dataSession),
            ExtendedTimes: fudaoDto.extendedTimes,
            PassedTimeMilliSecond: fudaoDto.passedTimeMilliSecond,
        });
    }
}
exports.FudaoClientFactory = FudaoClientFactory;
//# sourceMappingURL=FudaoClientFactory.js.map